import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { SubfooterCategory } from '../../type';
import { SubFooterDesktop } from './SubFooter.desktop';
import { SubFooterMobile } from './SubFooter.mobile';

export interface SubFooterProps {
    categories: SubfooterCategory[];
}

export const SubFooterSection = (props: SubFooterProps) => {
    const { categories } = props;
    const { desktop } = useAppDisplayModeContext();

    if (categories.length <= 0) {
        return null;
    }

    return desktop ? (
        <SubFooterDesktop categories={categories} />
    ) : (
        <SubFooterMobile categories={categories} />
    );
};
